module.exports = __webpack_public_path__ + "img/IQ.c392fbd7.png";